import { DatePicker } from "components/date/DatePicker"

import { PromotionCategory, PromotionStatus } from "services/promotions/type"

import { PROMOTION_CATEGORY_OPTIONS, PROMOTION_STATUS_OPTIONS } from "./constants"

type Props = {
  slug: string
  onSlugChange: (v: string) => void

  status: PromotionStatus
  onStatusChange: (v: PromotionStatus) => void

  categories: PromotionCategory[]
  onToggleCategory: (category: PromotionCategory, checked: boolean) => void

  is_active: boolean
  onIsActiveChange: (v: boolean) => void

  is_featured: boolean
  onIsFeaturedChange: (v: boolean) => void

  start_at: string | null
  onStartAtChange: (date: Date | null) => void

  end_at: string | null
  onEndAtChange: (date: Date | null) => void
}

export const PromotionGlobalFields = ({
  slug,
  onSlugChange,
  status,
  onStatusChange,
  categories,
  onToggleCategory,
  is_active,
  onIsActiveChange,
  is_featured,
  onIsFeaturedChange,
  start_at,
  onStartAtChange,
  end_at,
  onEndAtChange
}: Props) => {
  return (
    <>
      <div className="flex flex-col gap-4 border border-dashed border-[rgba(132,_0,_168,_0.8)] rounded-lg p-2">
        <div className="text-2xl">Global fields</div>
        <div>
          <label className="label block mb-1">Slug *</label>
          <input
            className="input input-bordered w-full"
            value={slug}
            onChange={(e) => onSlugChange(e.target.value)}
            placeholder="welcome-bonus-100"
          />
        </div>

        <div>
          <label className="label block mb-1">Status</label>
          <select
            className="select select-bordered w-full"
            value={status}
            onChange={(e) => onStatusChange(e.target.value as PromotionStatus)}
          >
            {PROMOTION_STATUS_OPTIONS.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.name}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="label block mb-1">Categories</label>
          <div className="flex flex-col gap-2">
            {PROMOTION_CATEGORY_OPTIONS.map((opt) => {
              const checked = categories.includes(opt.value)
              return (
                <label key={opt.value} className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    className="checkbox"
                    checked={checked}
                    onChange={(e) => onToggleCategory(opt.value, e.target.checked)}
                  />
                  <span>{opt.name}</span>
                </label>
              )
            })}
          </div>
        </div>

        <div className="flex items-center gap-4 mt-6">
          <label className="flex items-center gap-2 cursor-pointer">
            <input type="checkbox" className="checkbox" checked={is_active} onChange={(e) => onIsActiveChange(e.target.checked)} />
            <span>Active</span>
          </label>

          <label className="flex items-center gap-2 cursor-pointer">
            <input type="checkbox" className="checkbox" checked={is_featured} onChange={(e) => onIsFeaturedChange(e.target.checked)} />
            <span>Featured</span>
          </label>
        </div>

        <div>
          <label className="label block mb-1">Start At</label>
          <DatePicker
            selected={start_at ? new Date(start_at) : null}
            onChange={onStartAtChange}
            dateFormat="yyyy-MM-dd HH:mm"
            showTimeSelect
          />
        </div>

        <div>
          <label className="label block mb-1">End At</label>
          <DatePicker selected={end_at ? new Date(end_at) : null} onChange={onEndAtChange} dateFormat="yyyy-MM-dd HH:mm" showTimeSelect />
        </div>
      </div>
    </>
  )
}
